<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-md-8 col-sm-6 col-12">
          <h5>Online Applicants</h5>
        </div>
        <div class="col-md-4 col-sm-6 col-12 text-sm-right">
          <button class="btn btn-dark btn-sm" @click="handleBackClick">
            Go Back
          </button>
        </div>
      </div>
    </div>

    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="row">
          <!-- Form Status -->
          <div class="col-md-2 col-sm-3 col-12 mb-2">
            <p class="mb-0 font-weight-bold">Filter by form status</p>
            <a-select
              size="large"
              v-model="filterFormStatus"
              optionFilterProp="children"
              placeholder="All"
              style="width: 100%"
              @change="getApplicants"
              :filterOption="false"
            >
              <a-select-option :value="undefined">
                All
              </a-select-option>
              <a-select-option v-for="status in [0,1,3]" :value="status" :key="status">
                {{onlineApplicantFormStatus[status]}}
              </a-select-option>
            </a-select>
          </div>
          <div class="col-md-2 col-sm-3 col-12 mb-2">
            <p class="mb-0 font-weight-bold">Filter by status</p>
            <a-select
              size="large"
              v-model="filterStatus"
              optionFilterProp="children"
              placeholder="All"
              style="width: 100%"
              @change="getApplicants"
              :filterOption="false"
            >
              <a-select-option :value="undefined">
                All
              </a-select-option>
              <a-select-option v-for="status in [0,1,2,3]" :value="status" :key="status">
                {{onlineApplicantStatus[status]}}
              </a-select-option>
            </a-select>
          </div>
          <!-- Sort by Score-->
          <div class="col-md-2 col-sm-3 col-12 mb-2">
            <p class="mb-0 font-weight-bold">Sort by score</p>
            <a-select
              size="large"
              v-model="sortByScore"
              optionFilterProp="children"
              placeholder="None"
              style="width: 100%"
              @change="getApplicants"
              :filterOption="false"
            >
              <a-select-option :value="undefined">
                None
              </a-select-option>
              <a-select-option value="asc">
                Ascending
              </a-select-option>
              <a-select-option value="desc">
                Descending
              </a-select-option>
            </a-select>
          </div>
          <!-- Add new Applicant -->
          <!-- <div class="col-md-10 col-sm-9 col-12 text-sm-right">
            <add-application-form @created="handleCreated" />
          </div> -->
          <div class="col-md-6 col-sm-7 col-12 mb-2">
            <export-reports-form :formId="applicationFormId" />
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <applicants-table :data="data" :loading="loading" :applicationFormData="applicationFormData" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import { find } from 'lodash'
import { mapState } from 'vuex'

import { onlineApplicantFormStatus, onlineApplicantStatus } from '@/services/globaldata.js'

import ApplicantsTable from '@/components/applicant/Table/index'
// import AddApplicationForm from '@/components/applicationform/Forms/Add/index'
import ExportReportsForm from '@/components/applicationform/Report'

export default {
  components: {
    ApplicantsTable,
    ExportReportsForm,
    // AddApplicationForm,
  },
  mounted: function() {
    this.getApplicants()
    this.getApplicationForm()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      filterFormStatus: 3,
      filterStatus: undefined,
      sortByScore: undefined,
      data: [],
      dateFormat: 'DD-MM-YYYY',
      meta: {},
      applicationFormData: null,
      current: 1,
      pageSize: 30,
      onlineApplicantFormStatus,
      onlineApplicantStatus,
    }
  },
  computed: {
    ...mapState(['user']),
    applicationFormId: function() {
      return this.$route.params.formId
    },
  },
  methods: {
    getApplicants() {
      this.loading = true
      this.$http.get(`/api/online-applicants/${this.applicationFormId}`, {
        params: {
          filter_form_status: this.filterFormStatus,
          filter_status: this.filterStatus,
          sort_by_score: this.sortByScore,
        },
      })
        .then(({ data }) => {
          this.data = data.data
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
    getApplicationForm() {
      this.loading = true
      this.$http.get(`/api/online-application/${this.applicationFormId}`)
        .then(({ data }) => {
          this.applicationFormData = data.data
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
    handleCreated: function() {
      this.getApplicants()
    },
    handleUpdateTable: function() {
      this.getApplicants()
    },
    handleSessionChange (value) {
      if (value) {
        this.selectedSession = value
      } else {
        this.selectedSession = this.currentSession
      }

      this.getApplicants()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getApplicants()
    },
    onChange(current) {
      this.current = current
      this.getApplicants()
    },
    handleBackClick() {
      this.$router.push({ name: 'applicationforms' })
    },
  },
}
</script>
